import React, { useState, useEffect } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Column from './Column';
// import mocki from "../pages/mock.json"

import { getPropostas, updateProposta } from '../pages/api';
import { coresGrafico } from '../styles/styleUtils';

export default function KanbanBoard({ fluxo, etapas, filtro }) {
  // const propostaApi = getPropostas()
  const [tasksByStage, setTasksByStage] = useState({});
  const [propostas, setPropostas] = useState([]);
  // const [mock, setMock] = useState(mocki)

  const fetchPropostas = async (filtro) => {
    try {
      const resultado = await getPropostas(filtro);
      if (resultado) {
        setPropostas(resultado);
      }
    } catch (error) {
      console.log('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    fetchPropostas(filtro);
  }, [filtro]);

  useEffect(() => {
    const newTasksByStage = {};
    etapas.forEach((etapa) => {
      // Inicialize o array de tarefas com um objeto vazio para cada etapa
      newTasksByStage[etapa.nome] = [];
      // Filtrar as propostas do mock que têm o mesmo nome de etapa
      const propostasEtapa = propostas.filter(
        (proposta) => proposta.etapa.nome === etapa.nome && proposta.fluxo.id === fluxo.id
      );
      // Preencher as propostas na etapa correspondente
      newTasksByStage[etapa.nome] = propostasEtapa;
    });
    setTasksByStage(newTasksByStage);
  }, [propostas, etapas]);

  /*
  const handleDragEnd = (result) => {
    // draggableId está nulo, nao funcionando, olhar task dragend
    console.log(result)
    const { destination, source, draggableId } = result;
    // destination invalido, faz nada
    if (!destination) return;
    // mesmo destination, faz nada
    if (source.droppableId === destination.droppableId) return;

    const sourceStageName = etapas.find(etapa => etapa.id.toString() === source.droppableId)?.nome;
    const destinationStage = etapas.find(etapa => etapa.id.toString() === destination.droppableId);

    if (sourceStageName && destinationStage) {
      const propostaId = parseInt(draggableId, 10);
      console.log(propostaId)
      console.log(draggableId)
      const proposta = tasksByStage[sourceStageName].find(proposta => proposta._id === propostaId);
      console.log(proposta)
    
      console.log(tasksByStage)
      if (proposta) {
        const propostaIndex = propostas.findIndex(item => item._id === propostaId);
        if (propostaIndex !== -1) {
          const newPropostas = [...propostas];
          // Atualize o objeto etapa da proposta com o objeto de etapa completo
          newPropostas[propostaIndex].etapa = destinationStage;
          updateProposta(newPropostas[propostaIndex])
        }
      }
    }
  };
  */

  const onConfirmHandler = async (proposta, anexo) => {
    try {
      const [result1, result2] = await Promise.all([updateProposta(proposta, anexo)]);
      window.alert(result1.msg);

      fetchPropostas(filtro);
    } catch (error) {
      console.error('Erro ao atualizar as coleções:', error);
      // Lidar com erros, se necessário
    }
  };

  return (
    // <DragDropContext onDragEnd={handleDragEnd}>
    <DragDropContext>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        {etapas?.map((etapa, index) => {
          return (
            <Column
              key={etapa.id}
              title={etapa.nome}
              tasks={tasksByStage[etapa.nome]}
              id={etapa.id.toString()}
              columnColor={coresGrafico[index % coresGrafico.length]}
              onConfirm={onConfirmHandler}
            />
          );
        })}
      </div>
    </DragDropContext>
  );
}